export default __webpack_public_path__ + "static/media/sort-icon-down.dba55331.svg";